<template>
  <div class="content">
    <el-row :gutter="24">
      <el-col :span="leftSpan">
        <div class="left">
          <div id="content" ref="containerRef">
            <div :style="{maxWidth:isMobile?'85vw':'850px'}">
              <slot name="innerContent"></slot>
            </div>
          </div>
        </div>
      </el-col>
      <div class="right" ref="rightRef">
        <div class="right_inner">
          <div class="btn" ref="btnRef" @click="handleClickShow">
            <el-icon v-if="isClickFlag">
              <ArrowRight/>
            </el-icon>
            <el-icon v-else>
              <ArrowLeft/>
            </el-icon>
          </div>
          <el-anchor
              :container="containerRef"
              direction="vertical"
              type="default"
              :offset="30"
              style="height: 100vh;overflow: scroll"
              @click="handleClick"
          >
            <el-anchor-link
                v-for="item in localTitleList"
                :key="item.title"
                :href="item.href"
                :title="item.title"
            >
              <template #default>
                <div style="display: flex;justify-content: center;align-items: center">
                  <div style="margin-right: 10px;padding-top: 6px;" @click="toggleExpand(item.id)">
                    <el-icon v-if="item.isExpanded">
                      <CaretBottom/>
                    </el-icon>
                    <el-icon v-else>
                      <CaretRight/>
                    </el-icon>
                  </div>
                  <div>{{ item.title }}</div>
                </div>
              </template>
              <template #sub-link v-if="item.childList.length>0">
                <el-anchor-link
                    v-for="subItem in item.childList"
                    :key="subItem.title"
                    :href="subItem.href"
                    :title="subItem.title"
                    v-show="item.isExpanded"
                >
                  <template #default>
                    <span style="margin-left: 20px;">{{ subItem.title }}</span>
                  </template>
                </el-anchor-link>
              </template>
            </el-anchor-link>
          </el-anchor>
        </div>
      </div>
    </el-row>


  </div>
</template>

<script setup>
import {computed, ref} from "vue";

const leftSpan = ref(24);
const rightSpan = ref(0)

const isMobile = computed(() => {
  const ua = navigator.userAgent || navigator.vendor || window.opera

  if (/android/i.test(ua)) return true
  if (/iPad|iPhone|iPod/.test(ua)) return true
  if (/windows phone/i.test(ua)) return true

  return false
})

const isClickFlag = ref(false)
const rightRef = ref(null)
const btnRef = ref(null)
const handleClickShow = () => {
  if (!isClickFlag.value) {
    isClickFlag.value = true
    rightRef.value.style.width = "0px"
    btnRef.value.style.borderRadius = " 0px 4px 4px 0px "
  } else {
    isClickFlag.value = false
    rightRef.value.style.width = "300px"
    btnRef.value.style.borderRadius = "4px"
  }
}

const containerRef = ref(null)

const handleClick = (e) => {
  e.preventDefault()
}


const {titleList, isHasChild, titleChildList} = defineProps({
  titleList: {
    type: Array,
    default: () => []
  },
  titleChildList: {
    type: Array,
    default: () => []
  },
  isHasChild: {
    type: Boolean,
    default: false
  }
})

// 创建一个响应式的本地副本
const localTitleList = ref([...titleList])

const toggleExpand = (id) => {
  const item = localTitleList.value.find(item => item.id === id)
  if (item) {
    item.isExpanded = !item.isExpanded
    console.log(item.isExpanded, id, 'isExpanded')
  }
}

</script>
<style lang="less" scoped>

.content {
  width: 100%;
  height: 100%;
  background: white;
  position: relative;
  overflow: hidden;

  .left {
    width: 100%;
    height: max-content;
    text-align: left;
    //background: pink;
    position: relative;


    #content {
      width: 100%;
      height: 100vh;
      overflow: scroll;
      //background: red;
      margin: auto;

      & > div {
        height: 100vh;
        margin: auto;
      }
    }
  }

  .right {
    width: 300px;
    height: max-content;
    border-left: 2px solid #e7eaef;
    position: fixed;
    left: 0px;
    transition: all 0.3s;

    .right_inner {
      width: 100%;
      height: max-content;
      position: relative;
      transition: all 0.3s;

      .btn {
        width: 14px;
        height: 35px;
        color: gray;
        //background: yellow;
        box-shadow: rgb(230, 234, 240) 0px 0px 0px 1px, rgba(12, 31, 80, 0.04) 0px 4px 6px;
        left: 97%;
        top: 10px;
        border-radius: 4px;
        position: absolute;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 99;
        background: white;
        transition: all 0.3s;
      }

      .btn:hover {
        background: #417df7;
        color: white;
      }

    }
  }
}

:deep(.el-row) {
  height: 100%;
  transition: all 0.3s;
}

:deep(.el-col) {
  transition: all 0.3s;
}

:deep(.is-guttered) {
  padding: 0px !important;
}

:deep(.el-anchor__list:nth-of-type(2)) {
  padding: 40px 40px 40px 10px !important;
}

//#content {
//  width: 100%; /* 设置容器宽度 */
//  height: 300px; /* 设置容器高度 */
//  overflow: auto; /* 显示滚动条，根据内容决定是否显示 */
//
//  /* 隐藏默认的滚动条样式 */
//  scrollbar-width: none; /* Firefox */
//  -ms-overflow-style: none; /* IE and Edge */
//}
//
//#content::-webkit-scrollbar {
//  display: none; /* Chrome, Safari, and Opera */
//}

body {
  overflow: scroll;
}

:deep(.el-anchor__list div a) {
  font-size: 14px !important;
}


:deep(.el-anchor__link) {
  width: max-content !important;
}
</style>
